module.exports = __webpack_public_path__ + "media/images/mypage/btn04-4bcbd10938ba1ec84c030fec06015e31.gif";